<div class="options-container">
  <div class="header-part flex flex-row justify-start items-start">
    <button [disabled]="isOptionAdding" class="add-status" (click)="addOption()">Add Status
    </button>
  </div>
  <ul>
    <li *ngFor="let option of options; let i= index" class="flex flex-row justify-start items-center view-status-container">
      <div *ngIf="!option.isEditing" class="view-status-content">
        <mat-form-field class="without-label m-r-15" appearance="outline">
          <mat-label>Label</mat-label>
          <input matInput [placeholder]="'Label'" disabled="true" [value]="option.text">
        </mat-form-field>
        <mat-form-field class="custom-color-picker" appearance="outline">
          <mat-label>Color</mat-label>
          <mat-select [value]="option.tags[0]" disabled="true">
            <mat-select-trigger>
              <i class="selected-color" [ngStyle]="{'background-color': option.tags[0] }"></i>
            </mat-select-trigger>
            <mat-option *ngFor="let color of colors" [value]="color">
              <i [ngStyle]="{'background-color':color }"></i>
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="flex flex-row justify-start items-start" *ngIf="option.isEditing">
        <div *ngIf="option.isEditing">
          <form [formGroup]="editForm">
            <mat-form-field appearance="outline" style="flex: 0 0 350px">
              <mat-label>Label</mat-label>
              <input formControlName="title" matInput [placeholder]="'Title'" required>
              <mat-error *ngIf="editForm.controls['title'].hasError('required')">
                Title is required!
              </mat-error>
            </mat-form-field>
            <div style="position: relative">
              <mat-form-field appearance="outline" style="flex: 0 0 70px" class="custom-color-picker m-lr-10">
                <mat-label>Color</mat-label>
                <mat-select formControlName="color" (openedChange)="onOpenedChanged($event)">
                  <mat-select-trigger>
                    <i class="m-t-8"
                       [ngStyle]="{'background-color': editForm.controls['color'].value }"></i>
                  </mat-select-trigger>
                  <mat-option style="display: none" *ngFor="let color of colors" [value]="color"><i
                    [ngStyle]="{'background-color':color }"></i></mat-option>
                </mat-select>
                <mat-error *ngIf="editForm.controls['color'].hasError('required')">
                  Color is required!
                </mat-error>
              </mat-form-field>
              <ul class="status-dropdown" *ngIf="isStatusOptionSelectorVisible">
                <li *ngFor="let color of colors">
                  <a (click)="onSelectStatusColor(color)" class="pointer">
                    <i class="m-t-8" [ngStyle]="{'background-color': color }"></i>
                  </a>
                </li>
              </ul>
            </div>
          </form>
        </div>
        <button style="position: relative;top: 3px;" mat-button [disabled]="editForm.invalid"
                class="common-button p-tb-6" *ngIf="option.isEditing"
                (click)="onSaveOption(option)"
                particleAnalytics
                analyticsCategory="edit-item"
                analyticsAction="edit-item-btn">Save
        </button>
      </div>
      <button mat-button class="common-button p-tb-6" *ngIf="!option.isEditing"
              (click)="startEditItem(option)"
              [disabled]="!option.isCustom"
              particleAnalytics
              analyticsCategory="edit-item"
              analyticsAction="edit-item-btn">Edit
      </button>
      <button mat-icon-button
              class="trash-button icon-dropdown-button flex flex-row justify-center items-center"
              (click)="removeOption(option)"
              [disabled]="!option.isCustom"
              particleAnalytics
              analyticsCategory="edit-item"
              analyticsAction="edit-item-btn">
        <i class="far fa-trash"></i>
      </button>
    </li>
    <li *ngIf="isOptionAdding">
      <div>
        <form [formGroup]="editForm" class="full-grow-no-shrink-no-basis edit-form">
          <mat-form-field appearance="outline" style="flex:0 0 350px;" class="m-r-10">
            <mat-label>Label</mat-label>
            <input id="add-status-input" formControlName="title" matInput [placeholder]="'Title'" required>
            <mat-error *ngIf="editForm.controls['title'].hasError('required')">
              Title is required!
            </mat-error>
          </mat-form-field>
          <div style="position: relative">
            <mat-form-field class="custom-color-picker m-r-10" appearance="outline" style="flex: 0 0 70px">
              <mat-label>Color</mat-label>
              <mat-select formControlName="color" (openedChange)="onOpenedChanged($event)">
                <mat-select-trigger>
                  <i class="selected-color"
                     [ngStyle]="{'background-color': editForm.controls['color'].value }"></i>
                </mat-select-trigger>
                <mat-option style="display: none" *ngFor="let color of colors" [value]="color"><i
                  [ngStyle]="{'background-color':color }"></i></mat-option>
              </mat-select>
              <mat-error *ngIf="editForm.controls['color'].hasError('required')">
                Color is required!
              </mat-error>
            </mat-form-field>
            <ul class="status-dropdown" *ngIf="isStatusOptionSelectorVisible">
              <li *ngFor="let color of colors">
                <a (click)="onSelectStatusColor(color)">
                  <i class="m-t-8" [ngStyle]="{'background-color': color }"></i>
                </a>
              </li>
            </ul>
          </div>
          <button mat-button [disabled]="editForm.invalid" class="common-button"
                  (click)="onSaveNewOption()"
                  particleAnalytics
                  analyticsCategory="edit-item"
                  analyticsAction="edit-item-btn">Save
          </button>
          <button mat-icon-button class="trash-button icon-dropdown-button m-l-15"
                  (click)="resetOptionEditing()"
                  particleAnalytics
                  analyticsCategory="cancel-edit-item"
                  analyticsAction="cancel-edit-item-btn">
            <mat-icon>close</mat-icon>
          </button>
        </form>
      </div>
    </li>
  </ul>
</div>
